import React from 'react';
import '../../css/login.css';
import PropTypes from 'prop-types';

class OdpLoginRoute extends React.Component {
    render() {
        const {odpLoginRoute} = this.props;
        return (
            <a href={odpLoginRoute} className="odp-login-route">
                <div className="odp-login-route-icon">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/>
                        <circle cx="12" cy="7" r="4"/>
                    </svg>
                </div>
                <div className="odp-login-route-text">
                    <span className="odp-login-route-title">Accessing your personal account?</span>
                    <span className="odp-login-route-subtitle">Sign in with your Workday Digital ID.</span>
                </div>
                <div className="odp-login-route-arrow">
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M5 12h14"/>
                        <path d="M12 5l7 7-7 7"/>
                    </svg>
                </div>
            </a>
        );
    }
}

OdpLoginRoute.propTypes = {
    odpLoginRoute: PropTypes.string.isRequired
};

export default OdpLoginRoute;
